export enum UserDataStatus {
  Undefined = "Undefined",
  Ready = "Ready",
  WaitingForWork = "WaitingForWork",
  ValidationInProgress = "ValidationInProgress",
  Rejected = "Rejected",
}
